export const themesEnum = {
  DARK: 'DARK',
  LIGHT: 'LIGHT'
};
